import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@environments/environment';

export const TokenInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.headers.has('skipBearer')) {
    const token = window.sessionStorage.getItem('authToken');
    const ih = environment.IH_INICIAL;
    const authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        withCredentials: 'true',
        //'Access-Control-Allow-Origin': '*',
        Pragma: 'no-cache',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        IH: `${ih}`,
      },
    });
    return next(authReq);
  } else {
    const authReq = req.clone({
      setHeaders: {
        withCredentials: 'true',
        //'Access-Control-Allow-Origin': '*',
        Pragma: 'no-cache',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
      },
    });
    return next(authReq);
  }
};
